import { forwardRef, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import Barcode from 'react-barcode';
import { Button, Icon } from '@ts/storybook';
import Tooltip from '@components/Outputs/Tooltip';
import { IconButton } from '@mui/material';

interface ComponentToPrintProps {
  value: string;
}

const ComponentToPrint = forwardRef<HTMLDivElement, ComponentToPrintProps>(({ value }, ref) => {
  return (
    <div
      ref={ref}
      style={{
        position: 'absolute',
        left: '-10000px',
        top: 'auto',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
        textAlign: 'center',
      }}
    >
      <Barcode value={value} format="CODE128" />
    </div>
  );
});

interface BarcodePrinterProps {
  value: string;
  disabled?: boolean;
  btnMode?: boolean;
}

const BarcodePrinter = ({ value, disabled, btnMode }: BarcodePrinterProps) => {
  const componentRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: 'BarcodePrinter',
    ignoreGlobalStyles: true,
    pageStyle: `
    @media print {
      div {
        position: fixed !important;
        left: 50% !important;
        top: 0 !important;
        transform: translateX(-50%) !important;
        width: auto !important;
        height: auto !important;
        overflow: visible !important;
        text-align: center !important;
      }
    }
  `,
  });

  if (!value) return null;

  return (
    <>
      <ComponentToPrint ref={componentRef} value={value} />
      {btnMode ? (
        <Tooltip title="Barcode">
          <IconButton aria-label="expand row" size="small" onClick={handlePrint} sx={{ marginLeft: '20px', top: '-5px' }}>
            <Icon color="primary" icon="symbols_barcode_outlined" />
          </IconButton>
        </Tooltip>
      ) : (
        <Button onClick={handlePrint} variant="contained" type="submit" disabled={disabled} label="Print" />
      )}
    </>
  );
};

export default BarcodePrinter;
